module.exports = __webpack_public_path__ + "img/export_icon.a1c3ff67.svg";